"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commandQuery = commandQuery;
exports.configure = configure;
exports.reducer = void 0;

var _deepmergeTs = require("deepmerge-ts");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function commandQuery(state, action) {
  var _action$metadata5, _action$metadata6;

  switch (action.type) {
    case 'QUERY_COMPLETE':
      {
        var _action$metadata, _action$metadata$path, _action$metadata3;

        var current = state; // eslint-disable-next-line no-unused-expressions

        (_action$metadata = action.metadata) === null || _action$metadata === void 0 ? void 0 : (_action$metadata$path = _action$metadata.path) === null || _action$metadata$path === void 0 ? void 0 : _action$metadata$path.forEach(function (segment, index) {
          var _action$metadata$path2, _action$metadata2, _action$metadata2$pat;

          if (index + 1 < ((_action$metadata$path2 = (_action$metadata2 = action.metadata) === null || _action$metadata2 === void 0 ? void 0 : (_action$metadata2$pat = _action$metadata2.path) === null || _action$metadata2$pat === void 0 ? void 0 : _action$metadata2$pat.length) !== null && _action$metadata$path2 !== void 0 ? _action$metadata$path2 : 0)) {
            current = current[segment] || {};
          } else {
            delete current[segment];
          }
        });
        var newState = (0, _deepmergeTs.deepmerge)(state, action.payload); // eslint-disable-next-line @typescript-eslint/no-explicit-any

        delete newState.spot.active["".concat((_action$metadata3 = action.metadata) === null || _action$metadata3 === void 0 ? void 0 : _action$metadata3.correlationId)];
        return newState;
      }

    case 'COMMAND_COMPLETE':
      {
        var _action$metadata4;

        var _newState = _objectSpread({}, state); // eslint-disable-next-line @typescript-eslint/no-explicit-any


        delete _newState.spot.active["".concat((_action$metadata4 = action.metadata) === null || _action$metadata4 === void 0 ? void 0 : _action$metadata4.correlationId)];
        return _newState;
      }

    case 'QUERY':
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true,
        spot: _objectSpread(_objectSpread({}, state.spot), {}, {
          active: _objectSpread(_objectSpread({}, state.spot.active), {}, _defineProperty({}, "".concat((_action$metadata5 = action.metadata) === null || _action$metadata5 === void 0 ? void 0 : _action$metadata5.correlationId), true))
        })
      });

    case 'COMMAND':
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true,
        spot: _objectSpread(_objectSpread({}, state.spot), {}, {
          active: _objectSpread(_objectSpread({}, state.spot.active), {}, _defineProperty({}, "".concat((_action$metadata6 = action.metadata) === null || _action$metadata6 === void 0 ? void 0 : _action$metadata6.correlationId), true))
        })
      });

    case 'ERROR':
      {
        var _action$metadata7;

        var _newState2 = _objectSpread({}, state); // eslint-disable-next-line @typescript-eslint/no-explicit-any


        delete _newState2.spot.active["".concat((_action$metadata7 = action.metadata) === null || _action$metadata7 === void 0 ? void 0 : _action$metadata7.correlationId)];
        return _newState2;
      }

    case 'STATE_UPDATED':
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: Object.keys(state.spot.active).length > 0
      });

    default:
      return _objectSpread({}, state);
  }
}

function configure(state, action) {
  if (action.type === 'SETUP') {
    var baseUrl = action.payload.baseUrl;
    return _objectSpread(_objectSpread({}, state), {}, {
      baseUrl: baseUrl
    });
  }

  return _objectSpread({}, state);
}

function errors(state, action) {
  if (action.type === 'ERROR') {
    return [].concat(_toConsumableArray(state), [action.payload]);
  }

  return _toConsumableArray(state);
}

var reducer = function reducer(state, action) {
  if (state.config && state.config.debug) {
    /* eslint-disable no-console */
    console.debug('Got Action:', action);
    console.debug('Current State:', state);
  }

  return {
    config: configure(state.config, action),
    data: commandQuery(state.data, action),
    errors: errors(state.errors, action)
  };
};

exports.reducer = reducer;